'use client'

import { Result } from '../Search/Result'
import { Stack } from '@christiankaindl/lyts'
import { useSearch, useSearchResults } from '../Search/SearchProvider'
import Text from '../Text/Text'
import Placeholder from '../Placeholder/Placeholder'

export default function SearchResultsList ({ emptyText = 'Keine Ergebnisse gefunden' }: { emptyText?: string }) {
  const isPending = useSearch((state) => state.isPending)
  const error = useSearch((state) => state.error)
  const results = useSearchResults()

  return (
    <Stack
      style={{
        pointerEvents: isPending ? 'none' : undefined,
        transition: 'opacity 120ms',
        opacity: isPending ? 0.6 : undefined,
      }}
    >
      {error && (
        <Text align='center' style={{ maxWidth: 'unset' }} color='tertiary'>
          Ein Fehler ist aufgetreten, bitte versuche es später erneut.
        </Text>
      )}
      {!error && results?.grouped_hits?.map((hit) => {
        return (
          <Result key={hit.group_key.join()} result={hit} />
        )
      })}
      {!error && !isPending && (!results?.grouped_hits || results.grouped_hits.length === 0) && (
        <Text align='center' style={{ maxWidth: 'unset' }} color='tertiary'>
          {emptyText}
        </Text>
      )}
    </Stack>
  )
}

export function SearchResultsListLoading () {
  return (
    <Stack style={{ maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)' }}>
      <Placeholder type='image' width='100%' height='7em' />
      <Placeholder type='image' width='100%' height='7em' />
      <Placeholder type='image' width='100%' height='7em' />
    </Stack>
  )
}
